import { render, staticRenderFns } from "./FolderBreadcrumb.vue?vue&type=template&id=381da5fe&scoped=true"
import script from "./FolderBreadcrumb.vue?vue&type=script&lang=js"
export * from "./FolderBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./FolderBreadcrumb.vue?vue&type=style&index=0&id=381da5fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381da5fe",
  null
  
)

export default component.exports